import { TApplicationState } from '../../types/redux';

export function getIsEscrow(state: TApplicationState): boolean {
  return state.newbuilding.isEscrow || false;
}
